module.exports = __webpack_public_path__ + "static/media/welcome-right.98def0bc.png";